import { useRef, useInsertionEffect, useCallback } from 'react';

// Stable callback for event handlers and effect dependency lists.
// React's useEffectEvent cannot be called outside an effect or listed in deps.
const useEventCallback = fn => {
  const ref = useRef(null);
  useInsertionEffect(() => {
    ref.current = fn;
  }, [fn]);
  return useCallback((...args) => ref.current(...args), []);
};

export default useEventCallback;
